import React from "react";

export const HomeIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.79 22.75H6.21C3.47 22.75 1.25 20.52 1.25 17.78V10.37C1.25 9.00997 2.09 7.29997 3.17 6.45997L8.56 2.25997C10.18 0.999974 12.77 0.939974 14.45 2.11997L20.63 6.44997C21.82 7.27997 22.75 9.05997 22.75 10.51V17.79C22.75 20.52 20.53 22.75 17.79 22.75ZM9.48 3.43997L4.09 7.63997C3.38 8.19997 2.75 9.46997 2.75 10.37V17.78C2.75 19.69 4.3 21.25 6.21 21.25H17.79C19.7 21.25 21.25 19.7 21.25 17.79V10.51C21.25 9.54997 20.56 8.21997 19.77 7.67997L13.59 3.34997C12.45 2.54997 10.57 2.58997 9.48 3.43997Z"
        fill="currentColor"
      />
      <path
        d="M12 18.75C11.59 18.75 11.25 18.41 11.25 18V15C11.25 14.59 11.59 14.25 12 14.25C12.41 14.25 12.75 14.59 12.75 15V18C12.75 18.41 12.41 18.75 12 18.75Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const PersonalCardIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 21H7C3 21 2 20 2 16V8C2 4 3 3 7 3H17C21 3 22 4 22 8V16C22 20 21 21 17 21Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 8H19"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 12H19"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 16H19"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.49994 11.2899C9.49958 11.2899 10.3099 10.4796 10.3099 9.47992C10.3099 8.48029 9.49958 7.66992 8.49994 7.66992C7.50031 7.66992 6.68994 8.48029 6.68994 9.47992C6.68994 10.4796 7.50031 11.2899 8.49994 11.2899Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 16.33C11.86 14.88 10.71 13.74 9.26 13.61C8.76 13.56 8.25 13.56 7.74 13.61C6.29 13.75 5.14 14.88 5 16.33"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ServiceIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9983 22.7517H7.99827C3.37827 22.7517 2.51827 20.6017 2.29827 18.5117L1.54827 10.5017C1.43827 9.45172 1.40827 7.90172 2.44827 6.74172C3.34827 5.74172 4.83827 5.26172 6.99827 5.26172H16.9983C19.1683 5.26172 20.6583 5.75172 21.5483 6.74172C22.5883 7.90172 22.5583 9.45172 22.4483 10.5117L21.6983 18.5017C21.4783 20.6017 20.6183 22.7517 15.9983 22.7517ZM6.99827 6.75172C5.30827 6.75172 4.14827 7.08172 3.55827 7.74172C3.06827 8.28172 2.90827 9.11172 3.03827 10.3517L3.78827 18.3617C3.95827 19.9417 4.38827 21.2517 7.99827 21.2517H15.9983C19.5983 21.2517 20.0383 19.9417 20.2083 18.3517L20.9583 10.3617C21.0883 9.11172 20.9283 8.28172 20.4383 7.74172C19.8483 7.08172 18.6883 6.75172 16.9983 6.75172H6.99827Z"
        fill="currentColor"
      />
      <path
        d="M16 6.75C15.59 6.75 15.25 6.41 15.25 6V5.2C15.25 3.42 15.25 2.75 12.8 2.75H11.2C8.75 2.75 8.75 3.42 8.75 5.2V6C8.75 6.41 8.41 6.75 8 6.75C7.59 6.75 7.25 6.41 7.25 6V5.2C7.25 3.44 7.25 1.25 11.2 1.25H12.8C16.75 1.25 16.75 3.44 16.75 5.2V6C16.75 6.41 16.41 6.75 16 6.75Z"
        fill="currentColor"
      />
      <path
        d="M12 16.75C9.25 16.75 9.25 15.05 9.25 14.03V13C9.25 11.59 9.59 11.25 11 11.25H13C14.41 11.25 14.75 11.59 14.75 13V14C14.75 15.04 14.75 16.75 12 16.75ZM10.75 12.75C10.75 12.83 10.75 12.92 10.75 13V14.03C10.75 15.06 10.75 15.25 12 15.25C13.25 15.25 13.25 15.09 13.25 14.02V13C13.25 12.92 13.25 12.83 13.25 12.75C13.17 12.75 13.08 12.75 13 12.75H11C10.92 12.75 10.83 12.75 10.75 12.75Z"
        fill="currentColor"
      />
      <path
        d="M13.9995 14.7683C13.6295 14.7683 13.2995 14.4883 13.2595 14.1083C13.2095 13.6983 13.4995 13.3183 13.9095 13.2683C16.5495 12.9383 19.0795 11.9383 21.2095 10.3883C21.5395 10.1383 22.0095 10.2183 22.2595 10.5583C22.4995 10.8883 22.4295 11.3583 22.0895 11.6083C19.7495 13.3083 16.9895 14.3983 14.0895 14.7683C14.0595 14.7683 14.0295 14.7683 13.9995 14.7683Z"
        fill="currentColor"
      />
      <path
        d="M10.0007 14.7809C9.97072 14.7809 9.94072 14.7809 9.91072 14.7809C7.17072 14.4709 4.50072 13.4709 2.19072 11.8909C1.85072 11.6609 1.76072 11.1909 1.99072 10.8509C2.22072 10.5109 2.69072 10.4209 3.03072 10.6509C5.14072 12.0909 7.57072 13.0009 10.0707 13.2909C10.4807 13.3409 10.7807 13.7109 10.7307 14.1209C10.7007 14.5009 10.3807 14.7809 10.0007 14.7809Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CubeBoxIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9994 22.75C11.9394 22.75 11.8794 22.74 11.8294 22.73C11.7694 22.72 11.7094 22.69 11.6494 22.66L9.43938 21.56C9.06938 21.37 8.91937 20.92 9.09937 20.55C9.28937 20.18 9.73938 20.03 10.1094 20.21L11.2494 20.78V19.22C11.2494 18.81 11.5894 18.47 11.9994 18.47C12.4094 18.47 12.7494 18.81 12.7494 19.22V20.78L13.8894 20.21C14.2594 20.03 14.7094 20.18 14.8994 20.55C15.0894 20.92 14.9394 21.37 14.5594 21.56L12.3494 22.66C12.2894 22.69 12.2294 22.71 12.1694 22.73C12.1094 22.74 12.0594 22.75 11.9994 22.75ZM18.6694 19.42C18.3994 19.42 18.1294 19.27 17.9994 19.01C17.8094 18.64 17.9594 18.19 18.3394 18L20.1494 17.1V14.79C20.1494 14.38 20.4894 14.04 20.8994 14.04C21.3094 14.04 21.6494 14.38 21.6494 14.79V17.57C21.6494 17.85 21.4894 18.11 21.2394 18.24L19.0194 19.35C18.8894 19.39 18.7794 19.42 18.6694 19.42ZM5.32938 19.42C5.21938 19.42 5.09937 19.39 4.99937 19.34L2.77937 18.23C2.52937 18.1 2.36938 17.84 2.36938 17.56V14.78C2.36938 14.37 2.70938 14.03 3.11938 14.03C3.52938 14.03 3.86938 14.37 3.86938 14.78V17.09L5.67937 17.99C6.04937 18.18 6.19937 18.63 6.01937 19C5.86937 19.26 5.60938 19.42 5.32938 19.42ZM11.9994 14.42C11.5894 14.42 11.2494 14.08 11.2494 13.67V11.36L9.43938 10.46C9.06938 10.27 8.91937 9.82004 9.09937 9.45004C9.28937 9.08004 9.73938 8.93004 10.1094 9.11004L11.9994 10.05L13.8894 9.11004C14.2594 8.93004 14.7094 9.07004 14.8994 9.45004C15.0894 9.83004 14.9394 10.27 14.5594 10.46L12.7494 11.36V13.67C12.7494 14.08 12.4094 14.42 11.9994 14.42ZM20.8894 9.97004C20.4794 9.97004 20.1394 9.63004 20.1394 9.22004V7.66005L18.9994 8.23004C18.6294 8.42004 18.1794 8.27004 17.9894 7.89004C17.7994 7.52004 17.9494 7.07005 18.3294 6.88005L19.2094 6.44004L18.3294 6.00004C17.9594 5.81004 17.8094 5.36005 17.9894 4.99005C18.1794 4.62005 18.6294 4.47004 18.9994 4.65004L21.2094 5.75004C21.2294 5.76004 21.2594 5.77003 21.2794 5.79003C21.3394 5.82003 21.3894 5.87004 21.4394 5.92004C21.4694 5.96004 21.4994 6.00003 21.5294 6.04003C21.5694 6.11003 21.5994 6.18004 21.6194 6.26004C21.6294 6.32004 21.6394 6.38003 21.6394 6.43003V6.44004V9.20004C21.6394 9.64004 21.2994 9.97004 20.8894 9.97004ZM3.10938 9.97004C2.69938 9.97004 2.35938 9.63004 2.35938 9.22004V6.46005V6.45004C2.35938 6.39004 2.36937 6.33004 2.37937 6.28004C2.39937 6.20004 2.42938 6.13004 2.46938 6.06004C2.49938 6.01004 2.52937 5.97003 2.56937 5.93003C2.60937 5.89003 2.65937 5.85005 2.70937 5.82005C2.72937 5.81005 2.75937 5.79004 2.77937 5.78004L4.98937 4.68003C5.35937 4.50003 5.80937 4.64005 5.99937 5.02005C6.18937 5.40005 6.03938 5.84004 5.65938 6.03004L4.77937 6.47004L5.65938 6.91005C6.02938 7.10005 6.17937 7.55004 5.99937 7.92004C5.80937 8.29004 5.36937 8.44004 4.98937 8.26004L3.84937 7.69004V9.25004C3.85937 9.64004 3.52937 9.97004 3.10938 9.97004ZM14.2194 3.86004C14.1094 3.86004 13.9894 3.83004 13.8894 3.78004L11.9994 2.84004L10.1094 3.78004C9.73938 3.97004 9.28937 3.82004 9.09937 3.44004C8.90937 3.07004 9.05938 2.62003 9.43938 2.43003L11.6594 1.32005C11.8694 1.21005 12.1194 1.21005 12.3294 1.32005L14.5494 2.43003C14.9194 2.62003 15.0694 3.07004 14.8894 3.44004C14.7594 3.71004 14.4994 3.86004 14.2194 3.86004Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const EnvelopeIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 21.25H7C3.35 21.25 1.25 19.15 1.25 15.5V8.5C1.25 4.85 3.35 2.75 7 2.75H17C20.65 2.75 22.75 4.85 22.75 8.5V15.5C22.75 19.15 20.65 21.25 17 21.25ZM7 4.25C4.14 4.25 2.75 5.64 2.75 8.5V15.5C2.75 18.36 4.14 19.75 7 19.75H17C19.86 19.75 21.25 18.36 21.25 15.5V8.5C21.25 5.64 19.86 4.25 17 4.25H7Z"
        fill="currentColor"
      />
      <path
        d="M11.9988 12.87C11.1588 12.87 10.3088 12.61 9.6588 12.08L6.5288 9.57997C6.2088 9.31997 6.14881 8.84997 6.4088 8.52997C6.66881 8.20997 7.13881 8.14997 7.45881 8.40997L10.5888 10.91C11.3488 11.52 12.6388 11.52 13.3988 10.91L16.5288 8.40997C16.8488 8.14997 17.3288 8.19997 17.5788 8.52997C17.8388 8.84997 17.7888 9.32997 17.4588 9.57997L14.3288 12.08C13.6888 12.61 12.8388 12.87 11.9988 12.87Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const GithubIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
    >
      <path
        d="M12,1.5C6,1.4,1.1,6.3,1,12.3c0,4.7,3.1,8.8,7.5,10.2c0.6,0.1,0.8-0.2,0.8-0.5v-1.8c-3.1,0.6-3.7-1.4-3.7-1.4
	c-0.2-0.7-0.6-1.2-1.2-1.6c-1-0.7,0.1-0.6,0.1-0.6c0.7,0.1,1.3,0.5,1.7,1.1c0.6,1.1,2.1,1.5,3.2,0.9c0.1-0.5,0.3-1.1,0.7-1.4
	c-2.4-0.3-5-1.2-5-5.3c0-1.1,0.4-2.1,1.1-2.9C5.8,7.9,5.8,6.9,6.2,6c0,0,0.9-0.3,3,1.1c1.8-0.5,3.7-0.5,5.5,0c2.1-1.4,3-1.1,3-1.1
	c0.4,0.9,0.4,1.9,0.1,2.8c0.8,0.8,1.2,1.8,1.2,2.9c0,4.1-2.6,5-5,5.3c0.5,0.5,0.8,1.3,0.8,2v3c0,0.4,0.2,0.6,0.8,0.5
	c4.4-1.4,7.5-5.6,7.5-10.2C22.9,6.3,18,1.4,12,1.5"
      />
    </svg>
  );
};

export const LinkedInIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
    >
      <path
        d="M9,16.6v-7H6.7v7L9,16.6L9,16.6z M7.9,8.6c0.8,0,1.3-0.5,1.3-1.2c0-0.7-0.5-1.2-1.3-1.2c-0.8,0-1.3,0.5-1.3,1.2
	C6.6,8,7.1,8.6,7.9,8.6L7.9,8.6z M17.4,16.6v-4c0-2.2-1.2-3.2-2.7-3.2c-1.2,0-1.8,0.7-2.1,1.2v-1h-2.3c0,0.7,0,7,0,7h2.3v-3.9
	c0-0.2,0-0.4,0.1-0.6c0.2-0.4,0.6-0.9,1.2-0.9c0.8,0,1.2,0.6,1.2,1.6v3.8L17.4,16.6L17.4,16.6z M12,1.5c5.8,0,10.5,4.7,10.5,10.5
	c0,5.8-4.7,10.5-10.5,10.5C6.2,22.5,1.5,17.8,1.5,12C1.5,6.2,6.2,1.5,12,1.5z"
      />
    </svg>
  );
};

export const GmailIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
    >
      <path
        d="M21.6,10.2h-9.4V14h5.4c-0.2,1.3-0.9,2.3-2,3c-0.9,0.6-2,1-3.4,1c-2.6,0-4.8-1.8-5.6-4.1c-0.2-0.6-0.3-1.2-0.3-1.9
	s0.1-1.3,0.3-1.9C7.4,7.7,9.6,6,12.2,6C13.7,6,15,6.5,16,7.5l2.9-2.9C17.2,3,14.9,2,12.2,2C8.3,2,4.9,4.2,3.3,7.5
	C2.6,8.9,2.2,10.4,2.2,12s0.4,3.1,1.1,4.5c1.6,3.3,5,5.5,8.9,5.5c2.7,0,5-0.9,6.6-2.4c1.9-1.7,3-4.3,3-7.4
	C21.8,11.5,21.7,10.8,21.6,10.2z"
      />
    </svg>
  );
};

export const WhatsappIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
    >
      <path
        d="M12,1.6C6.2,1.6,1.5,6.3,1.5,12.1c0,2.2,0.7,4.4,2,6.1l-0.9,2.9c-0.1,0.2,0,0.4,0.1,0.5c0.1,0.1,0.3,0.2,0.5,0.1l3-1
	c4.8,3.2,11.3,1.9,14.6-2.9s1.9-11.3-2.9-14.6C16.1,2.2,14.1,1.6,12,1.6z M18.1,16.4c-0.4,0.8-1.2,1.3-2.1,1.5
	c-0.5,0.1-1.3,0.2-3.7-0.8c-2.1-1-4-2.6-5.2-4.6c-0.7-0.9-1.1-2-1.2-3.1c0-1,0.3-1.9,1-2.6c0.3-0.3,0.7-0.4,1-0.4h0.3
	c0.3,0,0.5,0,0.7,0.5S9.8,9,9.9,9.2C10,9.4,10,9.6,10,9.8c-0.1,0.2-0.2,0.3-0.3,0.5c-0.1,0.2-0.3,0.3-0.5,0.5
	c-0.2,0.2-0.3,0.4-0.1,0.7c0.5,0.8,1,1.5,1.7,2.1c0.7,0.7,1.6,1.2,2.5,1.5c0.2,0.1,0.5,0.1,0.7-0.1c0.3-0.3,0.6-0.7,0.8-1
	c0.2-0.3,0.5-0.4,0.8-0.2c0.3,0.1,1.8,0.8,2.1,1c0.3,0.1,0.5,0.2,0.6,0.4C18.3,15.5,18.3,16,18.1,16.4z"
      />
    </svg>
  );
};

export const FacebookIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
    >
      <path
        d="M13.6,22.4V15H16l0.4-2.9h-2.8v-1.9c0-0.5,0.1-0.8,0.3-1.1c0.2-0.2,0.6-0.4,1.1-0.4h1.5V6.1C16,6,15.3,6,14.3,6
	c-1.1,0-2,0.3-2.6,1c-0.7,0.7-1,1.6-1,2.9V12H8.3V15h2.4v7.4C5.5,21.8,1.5,17.3,1.5,12C1.5,6.2,6.2,1.5,12,1.5S22.5,6.2,22.5,12
	C22.5,17.3,18.6,21.6,13.6,22.4z M12,22.5L12,22.5C12,22.5,12,22.5,12,22.5z"
      />
    </svg>
  );
};

export const CallIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.45 22.75C16.32 22.75 15.13 22.48 13.9 21.96C12.7 21.45 11.49 20.75 10.31 19.9C9.14 19.04 8.01 18.08 6.94 17.03C5.88 15.96 4.92 14.83 4.07 13.67C3.21 12.47 2.52 11.27 2.03 10.11C1.51 8.87 1.25 7.67 1.25 6.54C1.25 5.76 1.39 5.02 1.66 4.33C1.94 3.62 2.39 2.96 3 2.39C3.77 1.63 4.65 1.25 5.59 1.25C5.98 1.25 6.38 1.34 6.72 1.5C7.11 1.68 7.44 1.95 7.68 2.31L10 5.58C10.21 5.87 10.37 6.15 10.48 6.43C10.61 6.73 10.68 7.03 10.68 7.32C10.68 7.7 10.57 8.07 10.36 8.42C10.21 8.69 9.98 8.98 9.69 9.27L9.01 9.98C9.02 10.01 9.03 10.03 9.04 10.05C9.16 10.26 9.4 10.62 9.86 11.16C10.35 11.72 10.81 12.23 11.27 12.7C11.86 13.28 12.35 13.74 12.81 14.12C13.38 14.6 13.75 14.84 13.97 14.95L13.95 15L14.68 14.28C14.99 13.97 15.29 13.74 15.58 13.59C16.13 13.25 16.83 13.19 17.53 13.48C17.79 13.59 18.07 13.74 18.37 13.95L21.69 16.31C22.06 16.56 22.33 16.88 22.49 17.26C22.64 17.64 22.71 17.99 22.71 18.34C22.71 18.82 22.6 19.3 22.39 19.75C22.18 20.2 21.92 20.59 21.59 20.95C21.02 21.58 20.4 22.03 19.68 22.32C18.99 22.6 18.24 22.75 17.45 22.75ZM5.59 2.75C5.04 2.75 4.53 2.99 4.04 3.47C3.58 3.9 3.26 4.37 3.06 4.88C2.85 5.4 2.75 5.95 2.75 6.54C2.75 7.47 2.97 8.48 3.41 9.52C3.86 10.58 4.49 11.68 5.29 12.78C6.09 13.88 7 14.95 8 15.96C9 16.95 10.08 17.87 11.19 18.68C12.27 19.47 13.38 20.11 14.48 20.57C16.19 21.3 17.79 21.47 19.11 20.92C19.62 20.71 20.07 20.39 20.48 19.93C20.71 19.68 20.89 19.41 21.04 19.09C21.16 18.84 21.22 18.58 21.22 18.32C21.22 18.16 21.19 18 21.11 17.82C21.08 17.76 21.02 17.65 20.83 17.52L17.51 15.16C17.31 15.02 17.13 14.92 16.96 14.85C16.74 14.76 16.65 14.67 16.31 14.88C16.11 14.98 15.93 15.13 15.73 15.33L14.97 16.08C14.58 16.46 13.98 16.55 13.52 16.38L13.25 16.26C12.84 16.04 12.36 15.7 11.83 15.25C11.35 14.84 10.83 14.36 10.2 13.74C9.71 13.24 9.22 12.71 8.71 12.12C8.24 11.57 7.9 11.1 7.69 10.71L7.57 10.41C7.51 10.18 7.49 10.05 7.49 9.91C7.49 9.55 7.62 9.23 7.87 8.98L8.62 8.2C8.82 8 8.97 7.81 9.07 7.64C9.15 7.51 9.18 7.4 9.18 7.3C9.18 7.22 9.15 7.1 9.1 6.98C9.03 6.82 8.92 6.64 8.78 6.45L6.46 3.17C6.36 3.03 6.24 2.93 6.09 2.86C5.93 2.79 5.76 2.75 5.59 2.75ZM13.95 15.01L13.79 15.69L14.06 14.99C14.01 14.98 13.97 14.99 13.95 15.01Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CallFillIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.05 14.95L9.2 16.8C8.81 17.19 8.19 17.19 7.79 16.81C7.68 16.7 7.57 16.6 7.46 16.49C6.43 15.45 5.5 14.36 4.67 13.22C3.85 12.08 3.19 10.94 2.71 9.81C2.24 8.67 2 7.58 2 6.54C2 5.86 2.12 5.21 2.36 4.61C2.6 4 2.98 3.44 3.51 2.94C4.15 2.31 4.85 2 5.59 2C5.87 2 6.15 2.06 6.4 2.18C6.66 2.3 6.89 2.48 7.07 2.74L9.39 6.01C9.57 6.26 9.7 6.49 9.79 6.71C9.88 6.92 9.93 7.13 9.93 7.32C9.93 7.56 9.86 7.8 9.72 8.03C9.59 8.26 9.4 8.5 9.16 8.74L8.4 9.53C8.29 9.64 8.24 9.77 8.24 9.93C8.24 10.01 8.25 10.08 8.27 10.16C8.3 10.24 8.33 10.3 8.35 10.36C8.53 10.69 8.84 11.12 9.28 11.64C9.73 12.16 10.21 12.69 10.73 13.22C10.83 13.32 10.94 13.42 11.04 13.52C11.44 13.91 11.45 14.55 11.05 14.95Z"
        fill="currentColor"
      />
      <path
        d="M21.9696 18.3291C21.9696 18.6091 21.9196 18.8991 21.8196 19.1791C21.7896 19.2591 21.7596 19.3391 21.7196 19.4191C21.5496 19.7791 21.3296 20.1191 21.0396 20.4391C20.5496 20.9791 20.0096 21.3691 19.3996 21.6191C19.3896 21.6191 19.3796 21.6291 19.3696 21.6291C18.7796 21.8691 18.1396 21.9991 17.4496 21.9991C16.4296 21.9991 15.3396 21.7591 14.1896 21.2691C13.0396 20.7791 11.8896 20.1191 10.7496 19.2891C10.3596 18.9991 9.96961 18.7091 9.59961 18.3991L12.8696 15.1291C13.1496 15.3391 13.3996 15.4991 13.6096 15.6091C13.6596 15.6291 13.7196 15.6591 13.7896 15.6891C13.8696 15.7191 13.9496 15.7291 14.0396 15.7291C14.2096 15.7291 14.3396 15.6691 14.4496 15.5591L15.2096 14.8091C15.4596 14.5591 15.6996 14.3691 15.9296 14.2491C16.1596 14.1091 16.3896 14.0391 16.6396 14.0391C16.8296 14.0391 17.0296 14.0791 17.2496 14.1691C17.4696 14.2591 17.6996 14.3891 17.9496 14.5591L21.2596 16.9091C21.5196 17.0891 21.6996 17.2991 21.8096 17.5491C21.9096 17.7991 21.9696 18.0491 21.9696 18.3291Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 5L4.99998 19M5.00001 5L19 19"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MenuIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 6H20M4 12H14M4 18H9"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UserIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1.25C9.37665 1.25 7.25 3.37665 7.25 6C7.25 8.62335 9.37665 10.75 12 10.75C14.6234 10.75 16.75 8.62335 16.75 6C16.75 3.37665 14.6234 1.25 12 1.25ZM8.75 6C8.75 4.20507 10.2051 2.75 12 2.75C13.7949 2.75 15.25 4.20507 15.25 6C15.25 7.79493 13.7949 9.25 12 9.25C10.2051 9.25 8.75 7.79493 8.75 6Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 12.25C9.96067 12.25 8.07752 12.7208 6.67815 13.5204C5.3 14.3079 4.25 15.5101 4.25 17C4.25 18.4899 5.3 19.6921 6.67815 20.4796C8.07752 21.2792 9.96067 21.75 12 21.75C14.0393 21.75 15.9225 21.2792 17.3219 20.4796C18.7 19.6921 19.75 18.4899 19.75 17C19.75 15.5101 18.7 14.3079 17.3219 13.5204C15.9225 12.7208 14.0393 12.25 12 12.25ZM5.75 17C5.75 16.2807 6.26701 15.483 7.42236 14.8228C8.55649 14.1747 10.1733 13.75 12 13.75C13.8267 13.75 15.4435 14.1747 16.5776 14.8228C17.733 15.483 18.25 16.2807 18.25 17C18.25 17.7193 17.733 18.517 16.5776 19.1772C15.4435 19.8253 13.8267 20.25 12 20.25C10.1733 20.25 8.55649 19.8253 7.42236 19.1772C6.26701 18.517 5.75 17.7193 5.75 17Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const GraduateCapIcon = () => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      width="26px"
      height="26px"
      viewBox="0 0 20 20"
    >
      <g>
        <g>
          <path
            fill="currentColor"
            d="M18.2,7.1L19,6.6l-9-4.1L1,6.6l9,4.1l7-3.2V10c-0.1,0.1-0.2,0.3-0.2,0.5c0,0.5,0.4,0.7,0.8,0.7
			s0.8-0.4,0.8-0.7c0-0.2-0.1-0.4-0.2-0.5L18.2,7.1L18.2,7.1z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="currentColor"
            d="M10,12L4.3,9.4v5.4c0,1.4,2.6,2.6,5.7,2.6s5.7-1.2,5.7-2.6V9.4L10,12z"
          />
        </g>
      </g>
    </svg>
  );
};

export const BriefcaseIcon = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.091 6.97953C20.241 6.03953 18.821 5.56953 16.761 5.56953H16.521V5.52953C16.521 3.84953 16.521 1.76953 12.761 1.76953H11.241C7.48101 1.76953 7.48101 3.85953 7.48101 5.52953V5.57953H7.24101C5.17101 5.57953 3.76101 6.04953 2.91101 6.98953C1.92101 8.08953 1.95101 9.56953 2.05101 10.5795L2.06101 10.6495L2.13847 11.4628C2.15273 11.6126 2.2334 11.7479 2.35929 11.8303C2.59909 11.9872 3.00044 12.2459 3.24101 12.3795C3.38101 12.4695 3.53101 12.5495 3.68101 12.6295C5.39101 13.5695 7.27101 14.1995 9.18101 14.5095C9.27101 15.4495 9.68101 16.5495 11.871 16.5495C14.061 16.5495 14.491 15.4595 14.561 14.4895C16.601 14.1595 18.571 13.4495 20.351 12.4095C20.411 12.3795 20.451 12.3495 20.501 12.3195C20.8977 12.0953 21.3093 11.819 21.6845 11.5484C21.7975 11.4668 21.8698 11.3408 21.8852 11.2023L21.901 11.0595L21.951 10.5895C21.961 10.5295 21.961 10.4795 21.971 10.4095C22.051 9.39953 22.031 8.01953 21.091 6.97953ZM13.091 13.8295C13.091 14.8895 13.091 15.0495 11.861 15.0495C10.631 15.0495 10.631 14.8595 10.631 13.8395V12.5795H13.091V13.8295ZM8.91101 5.56953V5.52953C8.91101 3.82953 8.91101 3.19953 11.241 3.19953H12.761C15.091 3.19953 15.091 3.83953 15.091 5.52953V5.57953H8.91101V5.56953Z"
        fill="currentColor"
      />
      <path
        d="M20.8733 13.7349C21.2269 13.5666 21.6342 13.8469 21.5988 14.2369L21.2398 18.1907C21.0298 20.1907 20.2098 22.2307 15.8098 22.2307H8.18984C3.78984 22.2307 2.96984 20.1907 2.75984 18.2007L2.41913 14.4529C2.38409 14.0674 2.78205 13.7874 3.13468 13.947C4.2741 14.4625 6.37724 15.3771 7.67641 15.7174C7.84072 15.7604 7.97361 15.878 8.04556 16.0319C8.65253 17.33 9.96896 18.0207 11.8698 18.0207C13.752 18.0207 15.085 17.3034 15.694 16.0021C15.766 15.8481 15.8991 15.7305 16.0635 15.6873C17.443 15.3243 19.6816 14.3019 20.8733 13.7349Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DownloadIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12ZM12 6.25C12.4142 6.25 12.75 6.58579 12.75 7V12.1893L14.4697 10.4697C14.7626 10.1768 15.2374 10.1768 15.5303 10.4697C15.8232 10.7626 15.8232 11.2374 15.5303 11.5303L12.5303 14.5303C12.3897 14.671 12.1989 14.75 12 14.75C11.8011 14.75 11.6103 14.671 11.4697 14.5303L8.46967 11.5303C8.17678 11.2374 8.17678 10.7626 8.46967 10.4697C8.76256 10.1768 9.23744 10.1768 9.53033 10.4697L11.25 12.1893V7C11.25 6.58579 11.5858 6.25 12 6.25ZM8 16.25C7.58579 16.25 7.25 16.5858 7.25 17C7.25 17.4142 7.58579 17.75 8 17.75H16C16.4142 17.75 16.75 17.4142 16.75 17C16.75 16.5858 16.4142 16.25 16 16.25H8Z"
        fill="currentColor"
      />
    </svg>
  );
};
